import DialogWrapper2 from '../../../../../core/dialog/dialog_wrapper_v2';
import { lazyInject } from '../../../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../../../core/trigger/trigger_service';
import { WActionButton } from '../../../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../../../core/table/WFormsTableWrapper';
import { validateFieldUniversal } from '../../../functions/validateField';

export interface DatenTabelleWrapperProps {
    configButton: any;
    configTable: any;
    onClose?: () => void;
}

export interface DatenTabelleWrapperState {
    showDialog: boolean;
}

export class DatenTabelleWrapper extends React.Component<DatenTabelleWrapperProps, DatenTabelleWrapperState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showDialog: false
        };
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        const configButton: any = this.props.configButton || {};
        const configTable: any = this.props.configTable || {};
        if (!configTable.entity) {
            return null;
        }
        return <>
            <WActionButton
                insideText={configButton.insideText}
                label={configButton.label || 'Datensatz hinzufügen'}
                key='datenTabelleWrapper_btn'
                action='calculator'
                onAction={() => this.setState({ showDialog: true })}
            />
            {this.state.showDialog &&
                <DialogWrapper2
                    width={-1}
                    onAfterClose={() => this.setState(
                        { showDialog: false }, () => typeof this.props.onClose === 'function' ? this.props.onClose() : null
                    )}
                >
                    <div style={{ minWidth: 800, maxWidth: 'calc(100vw - 40px)' }}>
                        <WFormsTableWrapper
                            entity={configTable.entity}
                            module={configTable.module}
                            preFilter={configTable.preFilter}
                            columnWidths={configTable.columnWidths}
                            actions={configTable.actions || ['add', 'edit', 'delete']}
                            customClass='Custom-ETA'
                            formLayout='flowV2'
                            tablePageSize={10}
                            validateField={this.validateField}
                            onDelDone={() => this.triggerService.fire('reload', configTable.entity)}
                            onSaveDone={() => this.triggerService.fire('reload', configTable.entity)}
                        />
                    </div>
                </DialogWrapper2>
            }
        </>;
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal((this.props.configTable || {}).entity, key, value, data, onValueChange);
    }
}
